/**
 * @description
 * @author: 菩萨蛮
 * @date 2020/9/17 2:09 下午
 * @version V1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行
 */
import OperateFactory from '@/plugins/factory/OperateFactory';

export default class NewFactory extends OperateFactory {
}
